import React, { useEffect, useState } from "react";
import { Form, Image } from '@themesberg/react-bootstrap';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faList } from "@fortawesome/free-solid-svg-icons";
import AuthUser from "../../components/AuthUser";
import { Apis } from "../../common/Apis";
import { useHistory } from "react-router-dom";
import { parseError } from "../../common/Utility";
import ErrorMsg from "../../common/ErrorMsg";
import Select from "react-select";

const Create = () => {
    const { http } = AuthUser();
    const [name, setName] = useState(null);
    const [thumbImage, setThumbImage] = useState(null);
    const [bannerImage, setBannerImage] = useState(null);
    const [status, setStatus] = useState("0");
    const [desp, setDesp] = useState(null);
    const [content, setContent] = useState(null);
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(null);
    const [error, setError] = useState(null);
    const history = useHistory();
    const [music_playlists, setMusicPlayLists] = useState(null);
    const [music_playlist, setMusicPlayList] = useState(null);

    useEffect(() => {
        http.get(Apis.radio.get_all_radio_songs)
        .then(res => {
            setMusicPlayLists(res.data.data);
        });
    }, []);

    const loadImage = (e, imgId) => {
        const output = document.getElementById(imgId);
        output.src = URL.createObjectURL(e.target.files[0]);
        output.onload = () => {
          URL.revokeObjectURL(output.src); // free memory
        }
        if (imgId === "img_thumb_preview")
            setThumbImage(e.target.files[0]);
        else if (imgId === "img_banner_preview")
            setBannerImage(e.target.files[0]);
    }

    const setStatusToState = (e) => {
        e.persist();
        setStatus(e.target.checked ? "1" : "0");
    }

    const handleSave = (e) => {
        e.preventDefault();
        setError(null);
        setLoading(true);

        const formData = new FormData();
        formData.append('music_song_id', music_playlist.value);
        const config = {
            headers: {
                // 'content-type': 'multipart/form-data'
            }
        };
        
        http.post(Apis.radio.create, formData, config)
        .then(res => {
            setLoading(false);
            setSuccess("Song added successfully!");
            setTimeout(() => {
                history.goBack();
            }, 800);
        })
        .catch(err => {
            setLoading(false);
            if (err.response.status === 400) {
                const errorMsg = parseError(err.response.data.error);
                setError(errorMsg);
            } else {
                setError([err.response.data.message]);
            }
        });
    }

    return (
        <div className="container">
            <div className="row">          
                <div className="col-sm-6 mt-3">
                    <h6 style={{ fontWeight: 'bold' }}><span><FontAwesomeIcon icon={ faList } /></span> BANNER <span style={{ fontSize: '12px', opacity: 0.5 }}>Create</span></h6>
                </div>
                <div className="col-sm-6 text-right mt-3">
                    
                </div>
            </div>
            {
              success && <div className="row mt-3">
                            <div className="col">
                                <div className="alert alert-success" style={{padding: '.5rem 1rem'}}>
                                    <strong>Success!</strong> {success}
                                </div>
                            </div>
                        </div>
            }
            {
                error && <ErrorMsg errors={error} />
            }
            <Form className="mt-4" onSubmit={ handleSave }>   

                <Form.Group id="category" className="mb-4">
                    <Form.Label>Music Song<span style={{ color: "red" }}> *</span></Form.Label>
                    <Select
                    required
                    isSearchable
                    isClearable
                    className="basic-multi-select"
                    classNamePrefix="select"
                    options={ music_playlists }
                    onChange={ setMusicPlayList } />
                </Form.Group>

                <button className="btn cust-button" style={{ backgroundColor: '#36c6d3', borderColor: '#2bb8c4', color: '#fff', fontSize: '12px', fontWeight: 'bold' }} disabled={loading}>
                    CREATE {loading && <span className="spinner-border spinner-border-sm" style={{marginLeft: '5px', width: '1rem', height: '1rem', verticalAlign: 'middle', animation: '1s linear infinite spinner-border'}}></span>}
                </button>
                <button type="button" className="btn btn-default ms-1" style={{ backgroundColor: '#eee', border: '1px solid #ccc', fontSize: '12px', fontWeight: 'bold' }} onClick={ () => history.goBack() }>CANCEL</button>
            </Form>
        </div>
    );
}
export default Create;